/* tslint:disable:no-trailing-whitespace */

import { IGroupLine } from './GroupLine';

/**
 * An externally-exposed representation of a group, living as an element in IQuery.groups.
 */
export interface IGroup {
    /**
     * The auto-generated id of the group.
     */
    id: string;
    /**
     * The condition of the group.
     */
    condition: Condition;
    /**
     * This attribute is an internal object representation of the group lines to be drawn for this group
     * by QueryBuilder.tsx. It will be populated by Helper.prepGroupLines() and stripped out by
     * Helper.unprepGroups(). The indexes of the array have no meaning as the lines don't have any
     * intrinsic order.
     */
    $$groupLines?: IGroupLine[];
}

export enum Condition {
    And = 'AND',
    Or = 'OR'
}
